document.addEventListener('alpine:init', () => {
  window.Alpine.store('pageData',{
    page: 1,
    maxPage: 1
  });

  window.Alpine.data('loader', ({action = '', page = 1, maxPage = 1, category = null, date = null, relativeLink = ''}) => ({
    posts: [],
    static: true,
    action,
    loading: false,
    paginationHidden: false,
    resetPagination: false,
    category,
    date,

    init () {
      this.$store.pageData.page = Number(page);
      this.$store.pageData.maxPage = Number(maxPage);
    },

    updatePosts () {
      this.updatePermalink();

      this.fetchItems();
    },

    updatePermalink () {
      const newLink = [
        relativeLink,
        this.category,
        this.date,
        this.$store.pageData.page
      ].filter(el => el).join('/');

      window.history.pushState('', '', newLink);
    },

    fetchItems () {
      const data = new FormData();
      this.loading = true;
      this.static = false;
      this.posts = [];

      data.append('action', this.action);
      data.append('page', this.$store.pageData.page);
      data.append('category', this.category);
      data.append('date', this.date);

      fetch('/wp/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: data,
      })
        .then(res => res.json())
        .then(({ items, pages }) => {
          this.posts = items;

          if (this.resetPagination) {
            this.$store.pageData.maxPage = -1;
            this.resetPagination = false;
          }

          this.$store.pageData.maxPage = Number(pages);

          this.loading = false;
          this.paginationHidden = false;

          this.$refs?.loader_container?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        });
    },

    shouldShowPagination() {
      return this.$store.pageData.maxPage > 1 && ! this.paginationHidden;
    }
  }));
});
